import { Box, Button, Drawer, Stack, Tooltip } from '@mui/material'
import React, { Component } from 'react'
import '../pharmaReports.css';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DataGrid } from '@mui/x-data-grid';
import { CommonGridToolBarWithFilterText } from '../../../../Components/Common Components/CommonComponents';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';
import { withTranslation } from 'react-i18next';
import PharmaFilter from '../PharmaFilter';
import { DateTime } from 'luxon';

class PharmaNoMovement extends Component {

    constructor(props) {
        super(props)
        this.state = {
            noMovementData: [],
            page: 0,
            pageSize: 10,
            rowCount: 0,
            dates: {
                'from_date': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                'to_date': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            },
            filterDatas: {
                'from_date': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                'to_date': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                "dateIndex": 1,
                'brandName': '',
                "dosageType": [],
                "movement_period": { value: 1, label: '1 Month' }
            },
            pageName: 'pharmaNoMovement',
            filterOpen: false,
            brandName: ''
        }
    }

    componentDidMount() {
        this.getPharmaNoMovementData()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    renderFilter = (data) => {
        this.setState({
            filterDatas: data,
            filterOpen: false,
        }, () => { this.getPharmaNoMovementData() })
    }

    ClosePopUp() {
        this.setState({
            filterOpen: false,
        })
    }

    clearFilter = (data) => {
        this.setState({
            filterDatas: data
        })
    }

    formatDayMonthAndYear = (value) => {
        if (value) {
            let [year, month, day] = value.split("-");

            return `${day}-${month}-${year}`;
        } else {
            return "-";
        }
    }


    gridToolBar = () => {
        var { t } = this.props
        let TextArray = [
            { label: "From Month", value: this.state.dates.from_date ? this.formatDayMonthAndYear(this.state.dates.from_date) : "-" },
            { label: "To Month", value: this.state.dates.to_date ? this.formatDayMonthAndYear(this.state.dates.to_date) : "-" },
        ]
        
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>

        )
    }

    getPharmaNoMovementData = () => {
        try {
            let brandName = this.state.filterDatas.brandName?.replaceAll('&', '%26')
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.PHARMA_NO_AND_SLOW_MOVEMENT_REPORT + `?brand_name=${brandName ? brandName : ""}&dosage_type=${this.state.filterDatas.dosageType ? this.state.filterDatas.dosageType : ""}&month=${this.state.filterDatas?.movement_period?.value ? this.state.filterDatas?.movement_period?.value : ""}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.setState({
                            noMovementData: response.data.data,
                            dates: response.data
                        }, () => { this.LoaderFunction(false) })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.LoaderFunction(false)
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.LoaderFunction(false)
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    

 getStockCorrectionLogExcel = () => {
        try {
            let brandName = this.state.filterDatas.brandName?.replaceAll('&', '%26')
            this.setState({ disableBtn: true })
            RestAPIService.excelGet(Serviceurls.PHARMA_NO_AND_SLOW_MOVEMENT_REPORT + `?brand_name=${brandName}&dosage_type=${this.state.filterDatas.dosageType}&month=${this.state.filterDatas?.movement_period?.value ? this.state.filterDatas?.movement_period?.value : ""}&export_type=excel`).
                then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 
                        let filename = response.headers["content-disposition"]?.split("filename=")[1]
                        // var blob = new Blob([csvContent], {type: 'data:application/vnd.ms-excel;base64'});
                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        this.setState({ disableBtn: false })
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message);
            this.setState({ disableBtn: false })
        }
    }


    getNoMovementPrint = () => {
        try {
            this.setState({ disableBtn: true })
            let brandName = this.state.filterDatas.brandName?.replaceAll('&', '%26')
            RestAPIService.getAll(Serviceurls.PHARMA_NO_AND_SLOW_MOVEMENT_REPORT + `?brand_name=${brandName}&dosage_type=${this.state.filterDatas.dosageType}&month=${this.state.filterDatas?.movement_period?.value ? this.state.filterDatas?.movement_period?.value : ""}&export_type=pdf`).
                then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    this.setState({ disableBtn: false })
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        this.errorMessage(error.response?.data?.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                    this.setState({ disableBtn: false })
                })
        } catch (error) {
            this.errorMessage(error.message)
            this.setState({ disableBtn: false })
        }
    }

    render() {
        const { t } = this.props
        this.state.noMovementData.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'drug_name', headerName: "Brand Name", flex: 0.167,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.drug_name?.length > 12 ? <Tooltip placement='top' title={params?.row?.drug_name} arrow><div>{params?.row?.drug_name?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.drug_name ? params?.row?.drug_name : '-'}
                </Box>)
            },
            {
                field: 'drug_type', headerName: "Dosage Type", flex: 0.167,
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.drug_type?.length > 12 ? <Tooltip placement='top' title={params?.row?.drug_type} arrow><div>{params?.row?.drug_type?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.drug_type ? params?.row?.drug_type : '-'}
                </Box>)
            },
            {
                field: 'drug_strength', headerName: "Dosage Strength", flex: 0.167, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.drug_strength?.length > 12 ? <Tooltip placement='top' title={params?.row?.drug_strength} arrow><div>{params?.row?.drug_strength?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.drug_strength ? params?.row?.drug_strength : '-'}
                </Box>)
            },
            {
                field: 'batch_no', headerName: "Batch No.", flex: 0.167, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>
                    {params?.row?.batch_no?.length > 12 ? <Tooltip placement='top' title={params?.row?.batch_no} arrow><div>{params?.row?.batch_no?.slice(0, 12) + '...'}</div></Tooltip> :
                        params?.row?.batch_no ? params?.row?.batch_no : '-'}
                </Box>)
            },
              {
                field: 'expiry_date',
                headerName: "Expiry Date",
                flex: 0.167,
                headerAlign: "center",
                align: "center",
                renderCell: (params) => (
                    <Box>{params.row?.expiry_date || 'NA'}</Box>
                ),
                sortComparator: (v1, v2) => {
                    if (!v1) return 1;
                    if (!v2) return -1;

                    const parse = (val) => {
                        const [month, year] = val.split('-').map(Number);
                        return { year, month };
                    };

                    const d1 = parse(v1);
                    const d2 = parse(v2);

                    
                    if (d1.year !== d2.year) return d1.year - d2.year;
                    return d1.month - d2.month;
                },
            },
            {
                field: 'last_bill_date', headerName: `Last Billed Date`, flex: 0.167, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params.row?.last_bill_date ? params.row?.last_bill_date : 'Not yet billed'}</Box>)
            },
            {
                field: 'age', headerName: `Age (Days)`, flex: 0.167, headerAlign: "center", align: "center",
                renderCell: (params) => (<Box component={'div'}>{params.row?.age ? params.row?.age : '0'}</Box>)
            }
        ]
        return (
            <Box component={'div'} height={'80vh'} sx={{ backgroundColor: Colors.Background }}>
                <Box component={'div'} className='eMed_Pharma_rts_header' sx={{ height: "7vh" }}>
                    <Box component={'div'} flex={0.8} display={'flex'}>

                    </Box>
                    <Box flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5vw'}>
                        <Button emed_tid="rpt_noMv_flt" className='eMed_Pharma_rts_btn' onClick={() => this.setState({ filterOpen: true })}>
                            <Box component={'img'} src={ImagePaths.Filter.default} alt='filter' height={'2.3vw'} width={'2.3vw'} />
                        </Button>
                        <Button emed_tid="rpt_noMv_print" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => { this.getNoMovementPrint() }}>
                            <Box component={'img'} src={ImagePaths.LabPrintIcon.default} alt='print' height={'2.3vw'} width={'2.3vw'} />
                        </Button>
                        <Button emed_tid="rpt_stkCrt_export" className='eMed_Pharma_rts_btn' disabled={this.state.disableBtn} onClick={() => this.getStockCorrectionLogExcel()}>
                            <Box component={'img'} src={ImagePaths.ExportIcon.default} alt='export' height={'2.3vw'} width={'2.3vw'} />
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} className='eMed_Pharma_rts_tbl_card' sx={{ height: "72vh" }}>
                    <DataGrid
                        className='eMed_Pharma_table'
                        rows={this.state.noMovementData}
                        columns={columns}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        getRowId={(row) => row['sno']}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: this.gridToolBar,
                            NoRowsOverlay: () => (
                                <Stack className='eMed_conf_nodata'>
                                    {t("NoRecordsFound")}
                                </Stack>
                            )
                        }}
                        rowCount={this.state.noMovementData?.length}
                        onPageChange={(newPage) => { this.setState({ page: newPage }) }}
                        onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                        rowsPerPageOptions={[10, 20, 30]}
                        headerHeight={40}
                        disableSelectionOnClick
                        pagination
                        loading={this.state.isLoader}
                    />
                </Box>

                <Drawer
                    anchor={'right'}
                    open={this.state.filterOpen}
                    ModalProps={{ onBackdropClick: this.ClosePopUp.bind(this) }}
                >
                    <PharmaFilter pageName={this.state.pageName} filterDatas={this.state.filterDatas} closeFilter={this.ClosePopUp.bind(this)} filteredData={this.renderFilter.bind(this)} ClearData={this.clearFilter.bind(this)} calDosType={true} />
                </Drawer>

                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}

export default withTranslation()(PharmaNoMovement)